import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'src/app/global';
import { ReplaySubject, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';

declare let gapi:any;

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  _loadedLibraries: { [url: string]: ReplaySubject<any> } = {};

  constructor(private http: HttpClient,@Inject(DOCUMENT) private readonly document: any) { }

  public obtenerClases(nombre_corto){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tipos/"+nombre_corto,GlobalVariable.httpOptions);
  }

  public obtenerClasesDatos(nombre_corto){
    return this.http.get(GlobalVariable.API_SERVER_URL+"clases/"+nombre_corto,GlobalVariable.httpOptions);
  }

  public obtenerClasesEmpresa(id_empresa,nombre_corto){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tipos/empresa/"+id_empresa+"/"+nombre_corto,GlobalVariable.httpOptions);
  }

  public obtenerTipoClaseDato(id_empresa,tipo_nombre_corto,clase_nombre_corto){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tipo/"+tipo_nombre_corto+"/clase/"+clase_nombre_corto+"/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public actualizarClase(clase){
    return this.http.put(GlobalVariable.API_SERVER_URL+"clase/"+clase.id,clase,GlobalVariable.httpOptions);
  }

  public actualizarTipo(tipo){
    return this.http.put(GlobalVariable.API_SERVER_URL+"tipos/"+tipo.id,tipo,GlobalVariable.httpOptions);
  }

  public crearTipo(tipo){
    return this.http.post(GlobalVariable.API_SERVER_URL+"tipos/empresa",tipo,GlobalVariable.httpOptions);
  }

  public obtenerContadorVencimientoProductos(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-vencimientos-productos/"+filtro.id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerContadorVencimientoCreditos(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-vencimientos-creditos/"+filtro.id_empresa+"/sucursal/"+filtro.id_sucursal+"/usuario/"+filtro.id_usuario,GlobalVariable.httpOptions);
  }

  public obtenerContadorVencimientoDeudas(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contador-vencimientos-deudas/"+filtro.id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerContadorVencimientoPagosEstudiantes(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-vencimientos-pagos-estudiantes/"+filtro.id_empresa+"/estado/1",GlobalVariable.httpOptions);
  }

  public obtenerContadorVencimientoPagosEstudiantesAnulados(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-vencimientos-pagos-estudiantes/"+filtro.id_empresa+"/estado/0",GlobalVariable.httpOptions);
  }

  public obtenerContadorAsuntosAdministrativos(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-asuntos-administrativos/"+filtro.id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerContadorPedidosNotificacion(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-pedidos-notificacion/sucursal/"+filtro.id_sucursal+"/usuario/"+filtro.id_usuario,GlobalVariable.httpOptions);
  }

  public obtenerContadorInventarioMinimo(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-inventario-minimo/empresa/"+filtro.id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerContadorResumenVentas(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-resumen-ventas/sucursales/"+filtro.id_sucursal,GlobalVariable.httpOptions);
  }

  public obtenerContadorMensajes(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-mensajes-usuario/"+filtro.id_usuario,GlobalVariable.httpOptions);
  }

  public obtenerTipos(paginator){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tipos/empresa/"+paginator.filter.id_empresa+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,GlobalVariable.httpOptions);
  }

  public obtenerTiposEmpresa(id_empresa,nombre_corto){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tipos/empresa/"+id_empresa+"/nombre-corto/"+nombre_corto,GlobalVariable.httpOptions);
  }

  public obtenerDatosApp(){
    return this.http.get(GlobalVariable.APP_DATA,GlobalVariable.httpOptions);
  }

  public obtenerDatosGece(){
    return this.http.get(GlobalVariable.SERVER_URL+"gece/datos.json",GlobalVariable.httpOptions);
  }

  public obtenerEscuela(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"empresa-escuela/"+id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerFechaHoraServidor(){
    return this.http.get(GlobalVariable.API_SERVER_URL+"snapquick-fecha",GlobalVariable.httpOptions);
  }

  public descargarDatosSin(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"sin-descargar-conceptos/"+id_empresa,GlobalVariable.httpOptions);
  }

  obtenerPosicionActual(): Promise<any>
  {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {

          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
        },
        err => {
          reject(err);
        });
    });

  }

  public agregarParticipantesGrupoWhatsapp(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"participantes-grupo-whatsapp",datos,GlobalVariable.httpOptions);
  }

  public obtenerContadorVentasNoContabilizadas(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-ventas-no-contabilizadas/empresa/"+filtro.id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerVentasNoContabilizadas(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"ventas-no-contabilizadas/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerContadorPagosVentaNoContabilizados(filtro){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-pagos-ventas-no-contabilizados/empresa/"+filtro.id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerPagosVentasNoContabilizadas(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"pagos-ventas-no-contabilizados/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerContadorJugadores(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"contar-jugadores-sin-carnet/"+id_empresa,GlobalVariable.httpOptions);
  }

  cargarGapiScript(url: string,reload,usar_google_class_room): Observable<any> {
    if (this._loadedLibraries[url] && !reload) {
        return this._loadedLibraries[url].asObservable();
    }

    var SCOPES = "email profile openid";      
    var DISCOVERY_DOCS = [];
    if(usar_google_class_room){console.log("entorrooror");
      SCOPES=SCOPES+" https://www.googleapis.com/auth/classroom.courses https://www.googleapis.com/auth/classroom.rosters https://www.googleapis.com/auth/classroom.profile.emails https://www.googleapis.com/auth/classroom.profile.photos https://www.googleapis.com/auth/classroom.announcements https://www.googleapis.com/auth/classroom.announcements.readonly";
      DISCOVERY_DOCS.push("https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest");
      DISCOVERY_DOCS.push("https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest");
    }
    this._loadedLibraries[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = async () => {
      var CLIENT_ID = '757097011374-6rihkus3f7hhjg1nknnko3fb8e56m398.apps.googleusercontent.com';
      var API_KEY = 'AIzaSyBGZAMgzLCjI5s0QGC83r6mmxP_bYu3FeE';
        let promGapi=new Promise((resolve, reject) => {
          gapi.load('client:auth2', async function() {
            await gapi.client.init({
              apiKey: API_KEY,
              clientId: CLIENT_ID,
              discoveryDocs: DISCOVERY_DOCS,
              scope: SCOPES
            })/*.then(function () {console.log(callBack);
              //callBack();
            }, function(error) {
              
            })*/;
            resolve({});
            //auth2 = gapi.auth2.getAuthInstance();
        
          });
        });
        await promGapi;
        this._loadedLibraries[url].next(undefined);
        this._loadedLibraries[url].complete();
    };

    this.document.body.appendChild(script);

    return this._loadedLibraries[url].asObservable();
  }
}
